module.exports = __webpack_public_path__ + "img/html.a2f6994b.png";